import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-terminal",
  "use": "icon-terminal-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-terminal\" id=\"icon-terminal\"><polyline points=\"4 17 10 11 4 5\" /><line x1=\"12\" y1=\"19\" x2=\"20\" y2=\"19\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol